enum FilterType {
  CyclePhase = 'cyclePhase',
  TimeUnit = 'timeUnit',
  Frequency = 'frequency',
}

export default FilterType;
